<template>
  <v-expansion-panel
    v-if="notes.adversity_resolution_comment"
  >
    <v-expansion-panel-header class="pl-2">
      <v-icon class="flex-grow-0 pr-4">
        note
      </v-icon>
      <span>Notes</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row
        class="text-caption"
      >
        <v-col>
          <p><strong>Regarding the adversity resolution:</strong></p>
          <p>{{ notes.adversity_resolution_comment }}</p>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

export default {
  name: 'PartyNotes',

  computed: {
    notes () {
      const adversityResolutionComment = this.peParty.adversity_resolution_comment

      return {
        ...(adversityResolutionComment && { adversity_resolution_comment: adversityResolutionComment }),
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },
}
</script>
